interface AuthorizedActionsModel {
   canCreateReviews: boolean;
   canStartTrial: boolean;
}

export const nullAuthorizedActionModel = (initialData?: Partial<AuthorizedActionsModel>): AuthorizedActionsModel => Object.assign({
   canCreateReviews: false,
   canStartTrial: false
}, initialData);

export default AuthorizedActionsModel;
